import { ItemList } from '../../orm'

class AdminCustomerIncomingFaxByEmailSettingsList extends ItemList {
    getEntityKey() {
        return "admin/customer_incoming_fax_by_email_settings"
    }
}

export const adminCustomerIncomingFaxByEmailSettingsList = new AdminCustomerIncomingFaxByEmailSettingsList("admin_customer_incoming_fax_by_email_settings__default")
